import SpriteSymbol from "../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "ico-nav-left",
  "use": "ico-nav-left-usage",
  "viewBox": "0 0 14.692 24.324",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 14.692 24.324\" id=\"ico-nav-left\">\n  <path id=\"ico-nav-left_Path_233\" data-name=\"Path 233\" d=\"M255,210.929l-12,11.005,12,11.495\" transform=\"translate(-241.172 -210.008)\" fill=\"none\" stroke=\"#4c6562\" stroke-width=\"2.5\" />\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol